<template>
  <div class="fp_list_container">
    <div class="fp_listgroup">
      <b-list-group>
        <b-list-group-item v-for="(o, i) in content" :key="i">
          <div class="fp_grp_item_first">
            <div
              class="fp_circle_color"
              :style="'background:' + colors[i] + ';'"
            ></div>
            <div class="listGroup_content_name">{{ o.name }}</div>
          </div>
          <div>{{ Math.round(o.value) }}%</div>
        </b-list-group-item>
      </b-list-group>
    </div>
  </div>
</template>
<script>
export default {
  props: ["content", "colors"],
  mounted() {
    console.log(this.content);
  }
};
</script>
<style lang="scss">
@import "./resources/sass/_variables.scss";

// ::-webkit-scrollbar {
//   width: 13px;
//   height: 13px;
// }
// ::-webkit-scrollbar-thumb {
//   background: #b3afb3;
//   border-radius: 55px;
// }
// ::-webkit-scrollbar-thumb:hover {
//   background: #b3afb3;
// }
// ::-webkit-scrollbar-track {
//   background: #f0f0f0;
//   border-radius: 50px;
//   box-shadow: inset 0px 0px 0px 0px #f0f0f0;
// }
.fp_list_container {
  display: flex;
  height: 100%;
  align-items: center;
  .fp_listgroup {
    border-radius: 30px;
    width: 100%;
    padding: 20px;
    background: $bg_color;
    display: flex;
    .fp_grp_item_first {
      display: flex;
      align-items: center;

      .listGroup_content_name {
        margin-left: 15px;
        margin-right: 15px;
      }
      .fp_circle_color {
        $nb: 30px;
        height: $nb;
        width: $nb;
        min-height: $nb;
        min-width: $nb;
        border-radius: $nb;
        // background: $purple_color;
        margin-right: 15px;
        box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px,
          rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
      }
    }
    .list-group {
      display: flex;
      flex-direction: column;
      padding-left: 0;
      margin-bottom: 0;
      border-radius: 0.25rem;
      max-height: inherit;
      overflow-y: scroll;
      width: 100%;
      max-height: 30vh;
    }
    .list-group-item {
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
      padding: 0.5rem 1rem;
      margin: 10px;
      border-radius: 30px;
      color: $mf_ft_color_lt;
      text-decoration: none;
      border: none;
      background: #e4e4e4;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px,
        rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
    }
  }
}
</style>